import { getPostponedDate } from './utils/getPostponedDate';

const localStorageDesktopAppNoticeCacheKey = '_desktop-app-notice-cache';

const localStorageDesktopAppPwaNoticeCacheKey = '_desktop-app-pwa-notice-cache';

export type DesktopAppNoticeCache = {
  expiresAt?: number;
};

export type DesktopAppNoticeCacheArgs = {
  daysToPostpone?: number;
};

/**
 * Sets the expire date to a localStorage cache.
 *
 * @param {DesktopAppNoticeCache}
 */
export function setLocalStorageDesktopAppNoticeCache({
  daysToPostpone = 7,
}: DesktopAppNoticeCacheArgs): void {
  localStorage.setItem(
    localStorageDesktopAppNoticeCacheKey,
    JSON.stringify({
      expiresAt: getPostponedDate(daysToPostpone),
    }),
  );
}

/**
 * Returns the cached value from localStorage.
 *
 * @returns {DesktopAppNoticeCache}
 */
export function getLocalStorageDesktopAppNoticeCache(): DesktopAppNoticeCache {
  const cache = localStorage.getItem(localStorageDesktopAppNoticeCacheKey);

  if (!cache) {
    return {};
  }

  return JSON.parse(cache) || {};
}

/** Sets the PWA notification seen. */
export function setDesktopAppPwaNoticeSeen(): void {
  localStorage.setItem(localStorageDesktopAppPwaNoticeCacheKey, 'true');
}

/**
 * Returns whether the notification is seen
 *
 * @returns {boolean}
 */
export function isDesktopAppPwaNoticeSeen(): boolean {
  return (
    localStorage.getItem(localStorageDesktopAppPwaNoticeCacheKey) === 'true'
  );
}
